<template>
  <v-container fluid class="ml-2 fill-height">
    <v-row class="mr-2 fill-height">
      <v-col cols="2">
        <v-list expand elevation="2" class="fill-height pt-0">
          <v-list-item v-if="queryParam.type==0" class="indigo font-weight-bold" dark @click="onSearch(0)">
            <v-list-item-title>所有工具</v-list-item-title>
          </v-list-item>
          <v-list-item v-else @click="onSearch(0)" class="font-weight-bold">
            <v-list-item-title>所有工具</v-list-item-title>
          </v-list-item>
          <v-divider />
          <template v-for="(item,index) in coder['CLOUD_TOOL_SERVICE_TYPE']">
            <v-list-item v-if="queryParam.type == item.code" class="indigo" dark :key="index" @click="onSearch(item.code)">
              <v-list-item-title>{{item.name}}</v-list-item-title>
            </v-list-item>
            <v-list-item v-else :key="index" @click="onSearch(item.code)">
              <v-list-item-title>{{item.name}}</v-list-item-title>
            </v-list-item>
          </template>
        </v-list>
      </v-col>
      <v-col cols="10" class="pt-0">
        <v-row justify="end">
          <v-col :cols="colWidth">
            <v-text-field dense class="rounded-0" hide-details label="请输入搜索关键词" single-line v-model="queryParam.searchValue" outlined prepend-inner-icon="mdi-magnify" @keydown.native="onSearchValueKeydown" />
          </v-col>
        </v-row>
        <v-row v-if="pagination.num!=0">
          <v-col v-for="(item,index) in dataList" :key="index" :cols="colWidth">
            <v-hover v-slot:default="{ hover }">
              <tool-item :elevation="hover ? 12 : 2" :item="item"></tool-item>
            </v-hover>
          </v-col>
          <v-col cols="12" v-if="pagination.num>1">
            <v-pagination v-model="pagination.index" :length="pagination.num" :total-visible="pagination.size" @input="onPage" />
          </v-col>
        </v-row>
        <v-row v-else>
          <v-col class="text-center text-h5 grey--text">
            暂无数据
          </v-col>
        </v-row>
      </v-col>

    </v-row>
  </v-container>
</template>
<script>
import { getToolList, getCoder } from '@/plugins/api';
export default {
  data () {
    return {
      colWidth: 3,
      coder: {},
      pagination: { index: 1, size: 12, num: 0, total: 0 },
      queryParam: { type: 0, searchValue: '' },
      dataList: []
    }
  },
  methods: {
    dataQuery (param) {
      getToolList(param).then(res => {
        this.dataList = res.data;
        this.pagination = res.pagination;
      })
    },
    onPage () {
      let param = { ...this.queryParam, pagination: { index: this.pagination.index, size: this.pagination.size } };
      this.dataQuery(param);
    },
    onSearch (type) {
      this.queryParam.type = type || 0;
      let param = { ...this.queryParam, pagination: { index: 1, size: this.pagination.size } };
      this.dataQuery(param);
    },
    onSearchValueKeydown (e) {
      if (e.keyCode == 13) this.onSearch()
    }
  },
  created () {
    getCoder(['CLOUD_TOOL_SERVICE_TYPE']).then(res => {
      this.coder = res.data;
    })
    this.onSearch();
  },
  components: {
    ToolItem: () => import('@/views/Component/ToolItem.vue')
  }
}
</script>